import React, { useState } from "react";
import {
  Alert,
  Button,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

const ApiKeyCreatedSuccessModal = ({ apiKey, onDone }) => {
  const [visible, setVisible] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      toast.success("API key copied to clipboard.");
    } catch {
      toast.error("Could not copy. Select and copy manually.");
    }
  };

  return (
    <Modal isOpen={true} size="md" backdrop="static" keyboard={false}>
      <ModalHeader className="border-bottom" tag="h5">
        API Key Created
      </ModalHeader>
      <ModalBody>
        <Alert
          className="mb-3 text-white border-0 rounded px-3 py-3"
          style={{ backgroundColor: "#f0ad4e" }}
        >
          <span className="d-block text-center small mb-0 px-2">
            Save your API key now. You won&apos;t be able to see it again after
            closing this dialog.
          </span>
        </Alert>
        <div className="text-dark font-weight-bold small">Your API Key</div>
        <InputGroup className="mt-1">
          <Input
            className="bg-light"
            type={visible ? "text" : "password"}
            value={apiKey}
            readOnly
            name="api-key"
            autoComplete="off"
          />
          <InputGroupText
            className="bg-light"
            onClick={() => setVisible((v) => !v)}
            style={{ cursor: "pointer" }}
            title={visible ? "Hide" : "Show"}
          >
            <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} />
          </InputGroupText>
          <Button
            color="primary"
            onClick={copy}
            className="d-flex align-items-center"
          >
            <FontAwesomeIcon icon={faCopy} className="mr-1" />
            Copy
          </Button>
        </InputGroup>
        <p className="text-muted small mt-2 mb-0">
          This key grants API access. Keep it secret and secure.
        </p>
      </ModalBody>
      <ModalFooter className="border-0">
        <Col>
          <Row className="justify-content-end">
            <Button color="primary" onClick={onDone}>
              Done
            </Button>
          </Row>
        </Col>
      </ModalFooter>
    </Modal>
  );
};

export default ApiKeyCreatedSuccessModal;
